<template>
    <!-- 招聘活动通知组件 -->
    <div @click="toDetail" class="item">
        <div>
            <div class="title">
                <div class="label">
                    <span>{{ title }}</span>
                    <div class="student" v-if="zplb == '1'">高校毕业生招聘</div>
                    <div class="student" v-if="zplb == '1'">专业岗</div>
                    <div class="student" v-if="zplb == '1'">校园招聘</div>
                    <div class="technic" v-if="zplb == '2'">高技能人才招聘</div>
                    <div class="technic" v-if="zplb == '2'">操作岗</div>
                    <div class="technic" v-if="zplb == '2'">校园招聘</div>
                    <div class="inside" v-if="zplb == '3'">内部公开招聘</div>
                    <div class="outside" v-if="zplb == '4'">社会化招聘</div>
                </div>

                <div v-show="showIcon" class="icon">
                    <img src="../assets/image/home/icon.png" alt="" />
                </div>
            </div>
            <div>
                <span class="start">报名开始时间：{{ startDate }}</span>
                <span class="end">报名截至时间：{{ endDate }}</span>
            </div>
        </div>
        <div v-if="showEnd === '1'">{{ date }}</div>
        <div class="end-img" v-if="showEnd === '0'">
            <img src="../assets/image/home/end.png" alt="" />
        </div>
    </div>
</template>

<script>
export default {
    name: "activity",
    props: {
        title: {
            type: String,
            default: "",
        },
        startDate: {
            type: String,
            default: "",
        },
        endDate: {
            type: String,
            default: "",
        },
        date: {
            type: String,
            default: "",
        },
        showIcon: {
            type: Boolean,
            default: false,
        },
        showEnd: {
            type: String,
            default: "",
        },
        id: {
            type: String,
            default: "",
        },
        /**
         * 招聘活动类型
         * 1：内部公开招聘&社会化招聘
         * 2：高校毕业生招聘&高技能人才招聘
         */
        type: {
            type: String,
            default: "",
        },
        /**
         * 招聘类别
         * 1：高校毕业生招聘
         * 2：高技能人才招聘
         * 3：内部公开招聘
         * 4：社会化招聘
         */
        zplb: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
    methods: {
        toDetail() {
            if (this.showEnd == "0") {
                return;
            }
            this.$router.push({
                name: "ActivityDetail",
                params: {
                    id: this.id,
                    type: this.type,
                    title: this.title,
                    date: this.date,
                    zplb: this.zplb,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.item {
    padding: 20px 0;
    border-bottom: 1px solid #d9d9d9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    .start {
        margin-right: 40px;
        font-size: 14px;
        color: #666;
        font-weight: 400;
    }
    .end {
        font-size: 14px;
        color: #666;
        font-weight: 400;
    }
    .end-img {
        width: 61px;
        height: 61px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .title {
        width: 100%;
        font-size: 18px;
        font-weight: 700;
        line-height: 27px;
        margin-bottom: 20px;
        position: relative;
        .icon {
            width: 31px;
            height: 17px;
            position: absolute;
            top: 0%;
            right: -9%;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .label {
            display: flex;
            flex-wrap: nowrap;
            .student {
                margin-left: 15px;
                border-radius: 25px;
                //width: 100px;
                background: #4788f0;
                padding-left: 15px;
                padding-right: 15px;
                font-size: 14px;
                color: aliceblue;
                font-weight: 200;
                text-align: center;
            }
            .technic {
                margin-left: 15px;
                border-radius: 25px;
                // width: 100px;
                background: #5ccea7;
                padding-left: 15px;
                padding-right: 15px;
                font-size: 14px;
                color: aliceblue;
                font-weight: 200;
                text-align: center;
            }
            .inside {
                margin-left: 15px;
                border-radius: 25px;
                //width: 100px;
                background: #c83640;
                padding-left: 15px;
                padding-right: 15px;
                font-size: 14px;
                color: aliceblue;
                font-weight: 200;
                text-align: center;
            }
            .outside {
                margin-left: 15px;
                border-radius: 25px;
                //width: 100px;
                background: #e9b26b;
                padding-left: 15px;
                padding-right: 15px;
                font-size: 14px;
                color: aliceblue;
                font-weight: 200;
                text-align: center;
            }
        }
    }
}
</style>
